/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { default as useAsync } from '../use-async';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { AsyncProps } from '../async';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { default } from '../async';
